import React, { Component } from 'react'
import { Grid, Header, Icon } from 'semantic-ui-react'
import map_icon from '../../../assets/images/newui/newrequestpage/map-view-icon.svg';

import './DisplayDistanceNew.less'
import { priceDisplay } from 'helpers/price';
import { changeLocationForRequest, saveHomeAddress } from 'services/Manager';

const initialState = {
    showDistanceDetails: true,
    from: '6909 wing In., La Puente',
    to: '16208 sigma st, Hacienda heights',
    distance: '',
    duration: ''
};

class DisplayDistance extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    processDistance = (distance) => {
        this.setState({
            from: distance.sourceAddress,
            to: distance.destinationAddress           
        })

        if(_.includes(Object.keys(distance), 'distance') && !_.isEmpty(distance.distance)){
            this.setState({distance: distance.distance.text})
        }

        if(_.includes(Object.keys(distance), 'duration') && !_.isEmpty(distance.duration)){
            this.setState({duration: distance.duration.text})
        }
    }

    componentDidMount(){
        if(this?.props?.sbr?.postProcessing?.distance && !_.isEmpty(this.props.sbr.postProcessing.distance)){
            this.processDistance(this.props.sbr.postProcessing.distance);
            this.setState({showDistanceDetails: true});
            this.props.isDistanchShow(true);
        }
        else{
            this.setState({showDistanceDetails: false});
            this.props.isDistanchShow(false);
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps?.sbr?.singleBuyerRequestID != this?.props?.sbr?.singleBuyerRequestID){
            if(this?.props?.sbr?.postProcessing?.distance && !_.isEmpty(this.props.sbr.postProcessing.distance)){
                this.processDistance(this.props.sbr.postProcessing.distance);
                this.setState({showDistanceDetails: true});
                this.props.isDistanchShow(true);
            }
            else{
                this.setState({showDistanceDetails: false});
                this.props.isDistanchShow(false);
            }
        }       
    }

    createLink = () => {
        const from = this.state.from.replace(' ', '+');
        const to = this.state.to.replace(' ', '+');
        
        return <a href={`https://www.google.com/maps/dir/${from}/${to}`} target="_blank">View</a>
    }

    changeLocation = async (newAddress) => {
        
        const res = await changeLocationForRequest(this.props.sbr.singleBuyerRequestID, newAddress);
        if(res.resStatus == 200){
            if(this.props.refreshMap){
                this.props.refreshMap(res.data.lat, res.data.lng);
            }
        }
    }
    
    render() {
        return (           
                this.state.showDistanceDetails &&
                <div style={{position:"relative"}}>
                <svg className={"distance-arrow"} xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
                            <path id="Polygon_9" data-name="Polygon 9" d="M6.5,0,13,8H0Z" transform="translate(8) rotate(90)" fill="#1e2022"/>
                </svg>
                <div className="distance-display-container-new">                  
                    
                    <Grid>
                        <Grid.Row className={"distance-container-row"}>
                            <Grid.Column width={16}>
                            {/* Estimated distance from <b>{this.state.from || "6909 wing In., La Puente"}</b> to <b>{this.state.to || "16208 sigma st, Hacienda heights"}</b> is <b className="distance">{this.state.distance || "4.7 mi"}</b> with an ETA of <b>{this.state.duration || "12 min"}</b> */}
                            <div className="estimate-container">
                                <div className="locations">
                                    <div className="location">
                                        <div className="start-pin pin">{<b>A</b>}</div>
                                        <div className='address'>{this.state.from}</div>
                                        <div className='location-icon-container' title='Set As Service Location' onClick={() => this.changeLocation(this.state.from)}>
                                                <svg id="Location" xmlns="http://www.w3.org/2000/svg" width="9.08" height="12.106" viewBox="0 0 9.08 12.106">

                                                    <defs>
                                                        <clipPath id="clip-path">
                                                            <rect id="Rectangle_8929" data-name="Rectangle 8929" width="9.08" height="12.106" fill="none" />
                                                        </clipPath>
                                                    </defs>
                                                    <g id="Group_16142" data-name="Group 16142" clip-path="url(#clip-path)">
                                                        <path id="Path_29385" data-name="Path 29385" d="M0,4.835A4.619,4.619,0,0,1,3.854.054,4.53,4.53,0,0,1,9.018,3.827a4.343,4.343,0,0,1-.677,3.188C7.64,8.067,6.9,9.093,6.179,10.13c-.4.571-.793,1.144-1.192,1.715a.505.505,0,0,1-.705.184.65.65,0,0,1-.188-.184C2.965,10.227,1.83,8.613.715,6.985A4.04,4.04,0,0,1,0,4.835m4.559,1.6A1.892,1.892,0,1,0,2.65,4.614,1.892,1.892,0,0,0,4.559,6.439" transform="translate(-0.001 0)" />
                                                    </g>
                                                </svg>
                                        </div>
                                    </div>
                                    <div className="location">
                                        <div className="end-pin pin">{<b>B</b>}</div>
                                        <div className='address'>{this.state.to}</div>
                                        <div className='location-icon-container' title='Set As Service Location' onClick={() => this.changeLocation(this.state.to)}>
                                                <svg id="Location" xmlns="http://www.w3.org/2000/svg" width="9.08" height="12.106" viewBox="0 0 9.08 12.106">

                                                    <defs>
                                                        <clipPath id="clip-path">
                                                            <rect id="Rectangle_8929" data-name="Rectangle 8929" width="9.08" height="12.106" fill="none" />
                                                        </clipPath>
                                                    </defs>
                                                    <g id="Group_16142" data-name="Group 16142" clip-path="url(#clip-path)">
                                                        <path id="Path_29385" data-name="Path 29385" d="M0,4.835A4.619,4.619,0,0,1,3.854.054,4.53,4.53,0,0,1,9.018,3.827a4.343,4.343,0,0,1-.677,3.188C7.64,8.067,6.9,9.093,6.179,10.13c-.4.571-.793,1.144-1.192,1.715a.505.505,0,0,1-.705.184.65.65,0,0,1-.188-.184C2.965,10.227,1.83,8.613.715,6.985A4.04,4.04,0,0,1,0,4.835m4.559,1.6A1.892,1.892,0,1,0,2.65,4.614,1.892,1.892,0,0,0,4.559,6.439" transform="translate(-0.001 0)" />
                                                    </g>
                                                </svg>
                                        </div>
                                    </div>
                                    <div className="location">       
                                    </div>          
                                </div>
                                <div className="estimate">
                                    <div className="distance">
                                        <div className={"icons_container"}>
                                            <svg id="Group_15791" data-name="Group 15791" xmlns="http://www.w3.org/2000/svg" width="20" height="11.839" viewBox="0 0 16.567 11.839">
                                            <defs>
                                                <clipPath id="clip-path">
                                                <rect id="Rectangle_8425" data-name="Rectangle 8425" width="16.567" height="11.839" fill="none"/>
                                                </clipPath>
                                            </defs>
                                            <g id="Group_15521" data-name="Group 15521" clip-path="url(#clip-path)">
                                                <path id="Path_29170" data-name="Path 29170" d="M7.59,0c0,.6.006,1.163,0,1.729-.005.343.033.4.37.4.252,0,.5,0,.757,0,.194,0,.255-.066.256-.261,0-.613,0-1.226,0-1.854.065,0,.12-.009.174-.009.993,0,1.985,0,2.978,0a.2.2,0,0,1,.224.149q2.067,5.735,4.142,11.466c.025.069.048.138.078.223H9.249c-.017-.515-.033-1.023-.05-1.531-.021-.641-.041-1.283-.065-1.924-.01-.261-.046-.3-.3-.307-.384-.01-.768-.011-1.152-.011-.171,0-.237.07-.244.262C7.415,8.9,7.4,9.473,7.38,10.045c-.021.594-.043,1.189-.066,1.793H0c.031-.089.057-.169.086-.249Q2.15,5.882,4.212.173A.213.213,0,0,1,4.453,0c.993.007,1.985,0,2.978,0ZM9.074,6.085H9.048c0-.372,0-.743,0-1.115,0-.486-.012-.973-.021-1.459,0-.2-.075-.266-.274-.267-.218,0-.435,0-.653,0-.442,0-.5-.065-.512.477-.021.978-.064,1.955-.1,2.932-.008.24.051.32.249.324q.541.011,1.083,0c.184,0,.248-.082.25-.274s0-.412,0-.618" transform="translate(0 0)"/>
                                                <path id="Path_29171" data-name="Path 29171" d="M218.881,96.842c0,.206,0,.412,0,.618s-.065.271-.25.274q-.541.01-1.083,0c-.2,0-.257-.085-.249-.324.031-.977.074-1.955.1-2.932.012-.542.071-.477.512-.477.218,0,.435,0,.653,0,.2,0,.27.07.274.267.009.486.016.973.021,1.459,0,.372,0,.743,0,1.115h.027" transform="translate(-209.806 -90.757)" fill="#fff"/>
                                            </g>
                                            </svg>
                                        </div>
                                        <div>{this.state.distance}</div>
                                    </div>
                                    <div className="eta">
                                        <div className={"icons_container"}>
                                            <Icon name="clock outline" size="large"></Icon>
                                        </div>
                                        <div>{this.state.duration}</div>
                                    </div>
                                    <div className="map-link">
                                        <div className={"icons_container"}>
                                        <img src={map_icon}></img>
                                        </div>
                                        <div className={"link"}>{this.createLink()}</div>
                                    </div>         
                                </div>                                 
                            </div>                              
                            </Grid.Column>                            
                        </Grid.Row>  
                        <Grid.Row>
                            {
                                !this.props.hidePricing ? 
                                <Grid.Column width={16}>
                            {
                                this.props.sbr && this.props.sbr.postProcessing && 
                                <div className="price-range-container" >
                                    <div className={"dollar-icon-container"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19">
                                            <text id="_" data-name="$" transform="translate(0 15)" fill="#1e2022" font-size="14" font-family="Roboto-Bold, Roboto" font-weight="700"><tspan x="0" y="0">$</tspan></text>
                                        </svg>
                                    </div>

                                    {"Price Range:  " } &nbsp;
                                        <b>
                                            <span>
                                                {
                                                    (this.props.sbr.postProcessing.priceRangeMin ? priceDisplay(this.props.sbr.postProcessing.priceRangeMin) : "N/A")
                                                }
                                            </span>

                                            {
                                                (this.props.sbr.postProcessing.price ? <span> {" - "}
                                                    <span className={"highlighted-price"}>{priceDisplay(this.props.sbr.postProcessing.price)}</span> {" - "}
                                                </span> : " - ")
                                            }

                                            <span>
                                                {
                                                    (this.props.sbr.postProcessing.priceRangeMax ? priceDisplay(this.props.sbr.postProcessing.priceRangeMax) : "N/A")
                                                }
                                            </span>
                                        </b>
                                </div>
                            }
                                </Grid.Column> 
                                : ""
                            }
                             
                        </Grid.Row>                     
                        {/*!this.state.showDistanceDetails && <Grid.Row>
                                <Grid.Column width={16}>
                                    No distance details found.
                                </Grid.Column>
                        </Grid.Row>*/}
                    </Grid> 
                </div>
                </div>
            
        )
    }
}

export default DisplayDistance
